module.exports = __webpack_public_path__ + "static/media/unverified-orders-tab.c6d380fb.svg";